<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      鹿丹村<br>
站点介绍<br>
鹿丹村站位于滨河大道和路中绿化带下，占用现有部分车道，与滨河大道程西北--东南走向。北侧为住宅区蔡屋围，东北侧是深圳较为出名的购物地点万象城，南侧有一栋高层写字楼深城投中心，西侧有滨河中学及红岭立交。鹿丹村站装修设计采用淡黄色为基调。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:25	23:05	9号线	3分50秒	5分55秒<br>
文锦	06:22	00:03	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:26	23:06	9号线	4分25秒	5分55秒<br>
文锦	06:21	00:03	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:26	00:06	9号线	4分钟	5分55秒<br>
文锦	06:19	01:03	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A1出入口:<br>
滨河大道南侧、深城投中心、红岭南苑、中海鹿丹名苑、滨河红岭立交<br><br>
A2出入口:<br>
滨苑铁路新村<br><br>
C出入口:<br>
木棉花街、华瑞大厦、幸福里<br><br>
D出入口:<br>
金塘街、深圳市罗湖高级中学、滨苑住宅小区、深圳市滨河小学<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 鹿丹村站<br>
8路、38路、73路、229路、337路、366路、M401路、M482<br><br>
C出入口:<br>
公交站名： 鹿丹村站<br>
73路、38路、229路、337路、366路、M182路、M401路、8路<br><br>
D出入口:<br>
公交站名： 鹿丹村站<br>
73路、38路、229路、337路、366路、M182路、M401路、8路<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>